import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from '../../lib'
import {doPROJECT_SET, doREQUEST_ERROR, doREQUEST_COMPLETE} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_PROJECT_UPDATE = 'REQUEST_PROJECT_UPDATE'
export const doREQUEST_PROJECT_UPDATE = createDoRequestAction(REQUEST_PROJECT_UPDATE)

export const requestProjectUpdateActionCreators = {
  doREQUEST_PROJECT_UPDATE,
}

export function* requestProjectUpdate({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestProject')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectId: v.string().uuid().exist(),
        name: v.string().optional(),
        investigator: v.string().optional(),
        organization: v.string().optional(),
        description: v.string().optional(),
        contactDescription: v.string().optional().allow(''),
        participantInstructions: v.string().optional().allow(''),
        backgroundSyncIntervalSeconds: v.number().optional().allow(null),
        type: v.string().valid('sample', 'template', 'user').optional(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_UPDATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {
    projectId,
    name,
    investigator,
    organization,
    description,
    contactDescription,
    participantInstructions,
    backgroundSyncIntervalSeconds,
    type,
  } = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/project-update`,
    accessToken,
    data: {
      projectId,
      name,
      investigator,
      organization,
      description,
      contactDescription,
      participantInstructions,
      backgroundSyncIntervalSeconds,
      type,
    },
  })

  // handle error
  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_UPDATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/project-update',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(doPROJECT_SET(result.payload))

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROJECT_UPDATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* projectUpdateSaga() {
  yield takeEvery(REQUEST_PROJECT_UPDATE, requestProjectUpdate)
}
